import {
  deleteExecutionProgressStatus,
  patchExecutionProgressStatus,
  postExecutionProgressStatus
} from 'api/executionProgressStatuses';
import {
  ExecutionProgressStatusFormValue,
  IPatchExecutionProgressStatusRequest,
  IPostExecutionProgressStatusRequest
} from 'types/forms/executionProgressStatuses';
import { IExecutionProgressStatus } from 'types/executionProgressStatuses';

const statusPayload = (
  status: ExecutionProgressStatusFormValue
): IPostExecutionProgressStatusRequest['execution_progress_status'] => ({
  kind: status.kind,
  confirmed_at: status.confirmed_at,
  execution_progress_tracking_id: status.execution_progress_tracking_id,
  approver_id: status.approver_id
});

const hasStatusChanged = (
  previous: IExecutionProgressStatus,
  next: ExecutionProgressStatusFormValue
) =>
  previous.kind !== next.kind ||
  previous.confirmed_at !== next.confirmed_at ||
  previous.execution_progress_tracking_id !== next.execution_progress_tracking_id ||
  previous.approver_id !== next.approver_id;

export const syncExecutionProgressStatuses = async (
  taskId: number,
  previous: IExecutionProgressStatus[] | undefined,
  next: ExecutionProgressStatusFormValue[] | undefined
) => {
  const previousStatuses = previous || [];
  const nextStatuses = next || [];
  const nextKinds = new Set(nextStatuses.map(({ kind }) => kind));

  for (const status of previousStatuses) {
    if (!nextKinds.has(status.kind)) {
      await deleteExecutionProgressStatus(taskId, status.id);
    }
  }

  for (const status of nextStatuses) {
    const existing = previousStatuses.find(({ kind }) => kind === status.kind);

    if (existing) {
      if (hasStatusChanged(existing, status)) {
        const payload: IPatchExecutionProgressStatusRequest = {
          execution_progress_status: statusPayload(status)
        };

        await patchExecutionProgressStatus(taskId, existing.id, payload);
      }

      continue;
    }

    const payload: IPostExecutionProgressStatusRequest = {
      execution_progress_status: statusPayload(status)
    };

    await postExecutionProgressStatus(taskId, payload);
  }
};
